/**
 * Central constants for the eSIM module.
 *
 * Keep all module-specific routes / opids / action codes here so that when the
 * folder is copied to another client codebase, only this single file needs to
 * be audited for environment-specific differences.
 */

export const ESIM_ROUTES = {
  LANDING: '/esim',
  PLANS: '/esim/plans',
  BOOKING: '/esim/booking',
  VOUCHER: '/esim/voucher/:transactionId',
};

export const ESIM_API = {
  OPID: 'MANAGEMATRIXESIM',
  ACTIONS: {
    GET_COUNTRIES: 'GETCOUNTRIES',
    GET_PLANS: 'GETPLANS',
    PERFORM_ESIM_BOOKING: 'PERFORMESIMOPERATION',
    GET_TRANSACTIONS: 'GETTRANSACTIONS',
    GET_ESIM_DETAILS: 'GETESIMDETAILS',
  },
  PLANS_PAGE_SIZE: 100,
};

export const PASSENGER_TITLE_OPTIONS = [
  { value: 'Mr', label: 'Mr' },
  { value: 'Mrs', label: 'Mrs' },
  { value: 'Ms', label: 'Ms' },
  { value: 'Miss', label: 'Miss' },
  { value: 'Mstr', label: 'Mstr' },
];

export const DEFAULT_NATIONALITY = {
  countryName: 'India',
  countryCode: 'IN',
};

export const ESIM_SORT_TABS = [
  { key: 'price-asc', label: 'Price Low to High' },
  { key: 'price-desc', label: 'Price High to Low' },
  { key: 'data-desc', label: 'Highest Data' },
  { key: 'validity-desc', label: 'Longest Validity' },
];

// Filter buckets surfaced on the plans page sidebar.
export const ESIM_DATA_BUCKETS = [
  { key: '0-1', label: 'Up to 1 GB', min: 0, max: 1 },
  { key: '1-5', label: '1 - 5 GB', min: 1, max: 5 },
  { key: '5-15', label: '5 - 15 GB', min: 5, max: 15 },
  { key: '15-50', label: '15 - 50 GB', min: 15, max: 50 },
  { key: '50+', label: 'Above 50 GB', min: 50, max: 9999 },
  { key: 'unlimited', label: 'Unlimited', min: -1, max: -1 },
];

export const ESIM_VALIDITY_BUCKETS = [
  { key: '0-7', label: 'Up to 7 Days', min: 0, max: 7 },
  { key: '7-15', label: '7 - 15 Days', min: 7, max: 15 },
  { key: '15-30', label: '15 - 30 Days', min: 15, max: 30 },
  { key: '30+', label: 'Above 30 Days', min: 30, max: 9999 },
];

// Six document slots supported by the booking payload.
export const ESIM_DOCUMENT_FIELDS = [
  {
    key: 'passportfronturl',
    label: 'Passport Front',
    required: true,
    helper: 'Front page of your passport (image or PDF).',
  },
  {
    key: 'passportbackurl',
    label: 'Passport Back',
    required: true,
    helper: 'Back / address page of your passport.',
  },
  {
    key: 'eticketurl1',
    label: 'E-Ticket (Onward)',
    required: true,
    helper: 'Confirmed onward flight or transport e-ticket.',
  },
  {
    key: 'eticketurl2',
    label: 'E-Ticket (Return)',
    required: false,
    helper: 'Confirmed return e-ticket (if available).',
  },
  {
    key: 'visacopyurl1',
    label: 'Visa Copy 1',
    required: false,
    helper: 'Soft copy of your destination country visa.',
  },
  {
    key: 'visacopyurl2',
    label: 'Visa Copy 2',
    required: false,
    helper: 'Additional visa page (if applicable).',
  },
];

// Travel-window guard rails for the search form.
export const ESIM_DATE_LIMITS = {
  // user can book starting today
  MIN_OFFSET_DAYS: 0,
  // up to a year out
  MAX_OFFSET_DAYS: 365,
  // shortest trip is 1 day, longest is 365 days
  MIN_TRIP_DAYS: 1,
  MAX_TRIP_DAYS: 365,
};
